/* =============================================================================
   Ella Custom JS - Customize The Style For Layout
   =============================================================================

   IMPORTANT DISCLAIMER
   Please use only JS to style the layout.
   ============================================================================= */

/* ============================================================================
   Macondo Bags - Colapsar variantes numeradas en la pagina de producto.
   Muestra las primeras 8 piezas (swatches de Swatch King) y agrega un boton
   "Ver todas" para el resto, en productos con muchas variantes (ej: 29 fotos).

   IMPORTANTE: algunos temas/apps renderizan MAS DE UNA cuadricula de swatches
   en la misma pagina (por ejemplo una version para desktop y otra oculta con
   CSS para mobile, o viceversa). Por eso este script no procesa solo la
   PRIMERA cuadricula que encuentra: busca TODOS los contenedores distintos
   que agrupan elementos ".swatch-view-item" y aplica el colapso a cada uno
   por separado, para que el comportamiento sea igual sin importar cuantas
   cuadriculas existan en el HTML.
   No modifica la app Swatch King, solo oculta/muestra despues de que ella
   ya genero los elementos en pantalla.
   ============================================================================ */
(function () {
  var MAX_VISIBLE = 8;

  function setupSwatchCollapse(container) {
    if (container.dataset.swatchCollapseInit) return;

    var items = container.querySelectorAll('.swatch-view-item');
    if (items.length <= MAX_VISIBLE) return;

    container.dataset.swatchCollapseInit = 'true';

    for (var i = MAX_VISIBLE; i < items.length; i++) {
      items[i].style.display = 'none';
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.textContent = 'Ver todas las ' + items.length + ' piezas disponibles';
    button.setAttribute('data-swatch-show-all', '');
    button.style.cssText = 'display:block;width:100%;margin-top:12px;padding:10px 16px;' +
      'background:#ffffff;border:1px solid #232323;color:#232323;font-size:13px;' +
      'letter-spacing:.02em;cursor:pointer;text-align:center;';

    button.addEventListener('click', function () {
      for (var i = 0; i < items.length; i++) {
        items[i].style.display = '';
      }
      button.remove();
    });

    container.insertAdjacentElement('afterend', button);
  }

  function processAllGrids() {
    var allItems = document.querySelectorAll('.swatch-view-item');
    if (allItems.length === 0) return false;

    var containers = [];
    allItems.forEach(function (item) {
      var parent = item.parentElement;
      if (parent && containers.indexOf(parent) === -1) {
        containers.push(parent);
      }
    });

    containers.forEach(function (container) {
      setupSwatchCollapse(container);
    });

    return true;
  }

  if (!processAllGrids()) {
    var swatchObserver = new MutationObserver(function () {
      if (processAllGrids()) {
        swatchObserver.disconnect();
      }
    });
    swatchObserver.observe(document.body, { childList: true, subtree: true });
  } else {
    // Ya se proceso al menos una cuadricula, pero por si el sitio inserta
    // una segunda cuadricula (mobile/desktop) un poco despues de forma
    // asincrona, seguimos observando un rato mas para no dejarla sin colapsar.
    var lateObserver = new MutationObserver(function () {
      processAllGrids();
    });
    lateObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      lateObserver.disconnect();
    }, 4000);
  }
})();
